import { render, staticRenderFns } from "./ParticipantScores.vue?vue&type=template&id=8808747a&"
import script from "./ParticipantScores.vue?vue&type=script&lang=js&"
export * from "./ParticipantScores.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantScores.vue?vue&type=style&index=0&id=8808747a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports